import {
    CLEAR_VOUCHER_DETAILS,
    ERROR_LOAD_VOUCHERS_LIST,
    FETCH_VOUCHER_DETAILS,
    LOAD_ACTIVE_VOUCHERS_LIST,
    LOAD_USED_VOUCHERS_LIST
} from '../actionsTypes'

const initialState = {
    usedVouchers: {},
    activeVouchers: {},
    currentVoucherDetails: {},
    error: null
};

const VoucherReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_USED_VOUCHERS_LIST:
            return {
                ...state,
                usedVouchers: action.payload,
            }
        case LOAD_ACTIVE_VOUCHERS_LIST:
            return {
                ...state,
                activeVouchers: action.payload,
            }
        case ERROR_LOAD_VOUCHERS_LIST:
            return {
                ...state,
                error: action.payload,
            }
        case FETCH_VOUCHER_DETAILS:
            return {
                ...state,
                currentVoucherDetails: action.payload,
            }
        case CLEAR_VOUCHER_DETAILS:
            return {
                ...state,
                currentVoucherDetails: {},  // réinitialiser les détails
            };

        default:
            return state;
    }
};

export default VoucherReducer;

